import generate from 'generate-maze';
import { Player } from '../../classes/Player';
import { Portal } from 'src/classes/Portal';
import VirtualJoyStick from 'phaser3-rex-plugins/plugins/virtualjoystick';
import UIScene from 'src/classes/UI/UIScene';
export default class MazeScene extends Phaser.Scene {
  mazeWidth: integer;
  mazeHeight: integer;
  wallWidth: integer;
  pathWidth: integer;
  cellWidth: integer;
  fullWidth: integer;
  fullHeight: integer;
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  maze: any[];
  exits: Portal[] = [];
  expandedMaze: Array<Array<integer>>;
  player: Player;
  joystick: VirtualJoyStick;
  floorTiles: integer[] = [
    160, 161, 103, 231, 112, 113, 115, 116, 117, 128, 129, 131, 132, 133,
  ];
  topTiles: integer[] = [108, 109, 110, 111];
  leftTiles: integer[] = [27, 43];
  compassAngle: number = 0;

  constructor(config) {
    super({ key: 'Maze Scene' });
    console.log('Maze Scene');

    // Test maze generation
    // Define Maze parameters
    this.mazeWidth = 22;
    this.mazeHeight = 22;
    this.wallWidth = 1;
    this.pathWidth = 5;
    this.cellWidth = this.wallWidth + this.pathWidth;
    this.maze = generate(this.mazeWidth, this.mazeHeight, true, 123456); //generate(this.mazeWidth, this.mazeHeight, true, 123456);

    // Initialize the expanded maze assuming there are no walls
    this.fullHeight = this.mazeHeight * (this.pathWidth + this.wallWidth);
    this.fullWidth = this.mazeWidth * (this.pathWidth + this.wallWidth);
    this.expandedMaze = new Array<Array<integer>>(this.fullHeight);
    for (var i = 0; i < this.fullHeight; i++) {
      // var row: Array<integer>(this.fullWidth);
      let baseRow = new Array<integer>(this.fullWidth);
      for (var j = 0; j < this.fullWidth; j++) {
        baseRow[j] = this.getRandomTile(this.floorTiles);
      }
      this.expandedMaze[i] = baseRow;
    }

    // Update the expanded array based on the
    for (var row = 0; row < this.maze.length; row++) {
      for (var col = 0; col < this.maze[0].length; col++) {
        let cell = this.maze[row][col];
        if (cell.left) {
          this.setLeftWall(row, col);
        }
        if (cell.top) {
          this.setTopWall(row, col);
        }
      }
    }
  }

  getRandomTile(arr) {
    // get random index value
    const randomIndex = Math.floor(Math.random() * arr.length);

    // get random item
    const item = arr[randomIndex];
    return item;
  }

  setTopWall(row, col) {
    let expandedRow: integer = row * this.cellWidth;
    let expandedCol: integer = col * this.cellWidth;
    for (var i = -1; i < this.cellWidth; i++) {
      let wallCol = i + expandedCol;
      for (var j = -1; j < this.wallWidth - 1; j++) {
        if (expandedRow + j >= 0) {
          this.expandedMaze[expandedRow + j][wallCol] = this.getRandomTile(
            this.topTiles
          );
        }
      }
    }
  }

  setLeftWall(row, col) {
    let expandedRow: integer = row * this.cellWidth;
    let expandedCol: integer = col * this.cellWidth;
    for (var i = 0; i < this.cellWidth; i++) {
      let wallRow = i + expandedRow;
      for (var j = -1; j < this.wallWidth - 1; j++) {
        if (expandedCol + j >= 0) {
          this.expandedMaze[wallRow][expandedCol + j] = this.getRandomTile(
            this.leftTiles
          );
        }
      }
    }
  }

  generateMazeMap() {
    const map = this.make.tilemap({
      data: this.expandedMaze,
      tileWidth: this.tileWidth,
      tileHeight: this.tileHeight,
    });

    map.addTilesetImage('caveTiles');
    const layer = map.createLayer(0, 'caveTiles', 0, 0);
    layer.setDepth(0);
    map.setCollision(this.leftTiles.concat(this.topTiles), true, false, 0);
    this.matter.world.convertTilemapLayer(layer);
    this.matter.world.setBounds(0, 0, map.widthInPixels, map.heightInPixels);
    this.cameras.main.setBounds(16, 0, map.widthInPixels, map.heightInPixels);
  }

  configureCameraForJoystick() {
    let { width, height } = this.sys.game.canvas;
    this.cameras.main.width = width;
    this.cameras.main.height = height;
    this.cameras.main.x = 0;
    this.cameras.main.y = 0;
  }

  leaveMaze() {
    this.scene.start('main');
  }

  preload() {
    // load the tileset image
    this.load.image('caveTiles', 'assets/sourceImages/cave.png');

    // load the PNG file
    this.load.image('catacomb', 'assets/sourceImages/mainlevbuild.png');

    // load the JSON file
    this.load.tilemapTiledJSON('tilemap', 'assets/scenes/catacomb.json');

    // Load portal assets
    Portal.preload(this);
  }

  create() {
    this.generateMazeMap();

    // Create a player
    this.player = new Player({
      scene: this,
      x: 2 * this.tileWidth,
      y: 5 * this.tileHeight,
      texture: 'player',
    });

    // Attach joystick to the player
    this.joystick = (
      this.scene.manager.getScene('UIScene') as UIScene
    ).customJoystick.joystick;
    this.player.cursors =
      this.joystick.createCursorKeys() as Phaser.Types.Input.Keyboard.CursorKeys;

    // Make camera follow player
    var cameraZoom = 1;
    this.cameras.main.setZoom(cameraZoom);
    this.cameras.main.startFollow(this.player, true, 0.05, 0.05);
    this.configureCameraForJoystick();

    // Add a cave exit
    this.exits[0] = new Portal({
      scene: this,
      x: 40,
      y: 32,
      width: this.tileWidth*2,
      height: this.tileHeight*2,
      texture: 'cave_exit',
      portalName: 'mainScene',
      prerequisites: null
    },
    1,
    true);
  }

  update(time: number, delta: number): void {
    // every 16ms. Game logic here
    this.player.update(this.joystick);
  }
}
